import React, { Component } from 'react';
import { Link, Route } from 'react-router-dom';
import {
    Search, DataTable, Loading, DataTableSkeleton,ButtonSkeleton,MultiSelect,
    TableContainer, Pagination, Form, FormLabel, TextInput, ComposedModal, ModalHeader, ModalBody, FormGroup, TableHead, Table, DropdownSkeleton, TableSelectRow, DatePickerSkeleton, TableBatchActions, TableBatchAction, TableBody, TableRow, TableCell, TableHeader, TableToolbar, TableToolbarContent, Button,
} from 'carbon-components-react';
import {  Document16, Tag } from '@carbon/icons-react/lib/';
import { getSuccess, getError, entitiesLabels, apioperation, DateFormat, LogOperation, LogModule } from '../../helpers/Constants';
import moment, { invalid } from 'moment';
import { activityLog, me, api, dynamic,kpi} from '../../helpers/api/api';
import { ComboBox } from '../../helpers/ComboBox';
import { RenderDataTableCell, NoRecordsPlaceholder } from '../../helpers/jsonschemaform/DataTableExtention';
import { AppContext } from '../../helpers/context/AppContext';
import PageBreadCrumb from '../../helpers/PageBreadCrumb';
import DateTimePicker from '../../helpers/DateTimePicker';
import { switchDateFormat } from '../../helpers/jsonschemaform/customwidget/utils';
import Data16 from '@carbon/icons-react/lib/data--1/16';
import { StatusTag } from '../../helpers/PageBreadCrumb';
import { v4 as uuid } from 'uuid';
import SimpleReactValidator from 'simple-react-validator';
import { Online } from '../common/OnLineOffLine';
import Add16 from '@carbon/icons-react/lib/add/16';
import Download16 from '@carbon/icons-react/lib/download/16';
import Edit16 from '@carbon/icons-react/lib/edit/16';
import Delete16 from '@carbon/icons-react/lib/delete/16';
import { ConfirmAlertCustom } from '../../helpers/ConfirmAlertCustom';
import { showNotification } from '../../helpers/notification/BaseNotification';
const baseUrl = '/admin/kpinotapplicable/';
const searchProp = {
  idKpi:null,
  quarter:null,
  listWorkSite:null,
  year:0
    
};
const modelProp= {
    idKpi:null,
    quarter:null,
    listWorkSite:null,
    year:0
}
export class KpiNotApplicable extends Component {
    constructor(props) {
        super(props);
        this.validator = new SimpleReactValidator();
        this.toggleSearchForm = this.toggleSearchForm.bind(this);
        this.state = {
            currentPage: 1,
            pageSize: 10,
            rowCount: 0,
            isLoading: false,//
            isLoadingList: false,//
            isLoadingEntity: false,//
            itemList: [],
            currentPage: 1,
            pageSize: 10,
            rowCount: 0,
            search: {
                ...searchProp
            },
            entityList: [],
           
            model:{
                ...modelProp
            },
            selectedItems: [],
            selectedItemsSearch: [],

            listKpiNotApplicable:[],
            listKpi: [],
            //Flags
            selecteKPI:true,
            selecteQuarter:true,

            isOpenDetailsModal: false,
            DetailModalId: null,
            kpiAI:[],
            quarter: [ 'Q1', 'Q2', 'Q3', 'Q4'],
            worksites:[],
            listWorkSites:[],
            isOpenDeleteModal: false,
            isDeleting: false,
            idToDelete:null,

            isOpenSearchForm:false,
        };
       
    }
    componentDidMount() {
        this.getKPINotApplicable();
        this.getKPIAI();
        this.getWorksite();
        this.getListKPIAINotApplicable();
        this.getListKPI();
    }
///Entity 

  //Get
    getKPINotApplicable = async   (param) =>  {
        this.setState({
            isLoadingEntity:true
        });
        const filter= {
          page: param && param.page ? param.page : this.state.currentPage,
          pageSize: param && param.pageSize ? param.pageSize : this.state.pageSize,
          idKpi:this.state.search.idKpi,
          quarter:this.state.search.quarter,
          listWorkSite: this.state.search.listWorkSite != null && this.state.search.listWorkSite.length  > 0
          ? this.state.search.listWorkSite?.map((f) => f.id).join('|')
          : [],
          year:this.state.search.year,
            
        };
       let data = {
            params: {
             ...filter,
              
            },}
            
     kpi
      .getWithParam(data)
      .then((response) => {
        if (response.status === 200) {
          const { data } = response;
          var  kpis = data.itemList.sort((a, b) => {
            const codeA = a.code.toUpperCase();
            const codeB = b.code.toUpperCase();
            return codeA < codeB ? -1 : codeA > codeB ? 1 : 0;});
          this.setState({
            data,
            currentPage: data.currentPage,
            pageSize: data.pageSize,
            rowCount: data.rowCount,
            itemList: kpis,
            isLoadingEntity:false
          });
        } else {
          showNotification.error();
        }
      })
      .catch((error) => {
        showNotification.error(`${entitiesLabels.ERROR}`,getError(error, entitiesLabels.KpiNotApplicable, apioperation.GET));
      })
      .finally(() => {
        this.setState({
            isLoadingEntity:false
        });
    });
    }
    getKPIAI = () => {
        dynamic
        .getAll('kpiai', { params: { page: 0 , asst:1} })
          .then((response) => {
            var data = response.data.itemList;

            data = data.sort((a, b) => {
              const codeA = a.code.toUpperCase();
              const codeB = b.code.toUpperCase();
              return codeA < codeB ? -1 : codeA > codeB ? 1 : 0;});
            this.setState({
                kpiAI: data,
            });
          })
          .catch((error) => {
            showNotification.error(`${entitiesLabels.ERROR}`,getError(error, entitiesLabels.KpiNotApplicable, apioperation.GET));
          })
          .finally(() => {});
    }
    getListKPIAINotApplicable = () => {
      dynamic
      .getAll('kpinotapplicable', { params: { page: 0 , asst:1} })
        .then((response) => {
          var data = response.data.itemList;
          this.setState({
              listKpiNotApplicable: data,
          });
        })
        .catch((error) => {
          showNotification.error(`${entitiesLabels.ERROR}`,getError(error, entitiesLabels.KpiNotApplicable, apioperation.GET));
        })
        .finally(() => {});
  }
  getListKPI= () => {
    kpi
    .getAll()
      .then((response) => {
        var data = response.data;
        this.setState({
            listKpi: data,
        });
      })
      .catch((error) => {
        showNotification.error(`${entitiesLabels.ERROR}`,getError(error, entitiesLabels.KpiNotApplicable, apioperation.GET));
      })
      .finally(() => {});
}
    getWorksite = () => {
        api
        .getWithParam('/worksite', { params: { page: 0 }  })
        .then((response) => {
            var data = response.data.itemList.filter(el=> el.asset == true);
            this.setState({
              worksites: data,
                listWorkSites:data,
            });
        })
        .catch((error) => {
           showNotification.error(`${entitiesLabels.ERROR}`,getError(error, entitiesLabels.WORKSITE, apioperation.GET));
                  })
        .finally(() => {});
    }    
    getKPIForEdit(id) {
        this.setState({
          isEditModal: true,
          isLoadingWorkSiteData: true,
          isOpenInsertModal: true,
        });
        const kpiToChange = this.state.itemList.find(x => x.id == id)
        var listWorkSites=[];
      
        if(kpiToChange.idKpi != null && kpiToChange.year != null && kpiToChange.quarter != null ){
            var listWSkpinotApplicable= this.state.listKpi.find( ws => ws.idKpi ==  kpiToChange.idKpi &&   ws.year ==  kpiToChange.year &&  ws.quarter ==  kpiToChange.quarter );
            if(listWSkpinotApplicable != null && listWSkpinotApplicable.listWorkSite!= null ){
                const filterWs =  this.state.worksites.filter( x =>  !listWSkpinotApplicable.listWorkSite.some(y => y.id == x.id) )
                listWorkSites= filterWs;
            }else{
                listWorkSites = this.state.worksites;
            }
        }
       this.setState({
            //idWorkSiteEdit: id,
            model: kpiToChange,
            selectedItems:kpiToChange.listWorkSite,
            listWorkSites:listWorkSites,
            oldIdKpi:kpiToChange.idKpi,
            
            oldYear: kpiToChange.year,
            oldQuarter: kpiToChange.quarter
          });
      } 
  ///Post
    insertKpiNotApplicable = () => {
        if (this.validator.allValid()) {
          this.setState({
            isSubmitted: true,
            spinner: true,
          });
    
          const datiForm = this.state?.model;
          const oldDatiForm= [];
          if (!this.state.isEditModal) {
            datiForm.id = uuid();
          }else{
            datiForm.oldIdKpi = this.state.oldIdKpi ;
            datiForm.oldYear=  this.state.oldYear;
            datiForm.oldQuarter=  this.state.oldQuarter;
          }
          const method = this.state.isEditModal
            ? kpi.put( datiForm)
            : kpi.post( datiForm);
    
          method
            .then(async (response) => {
              if (response.status === 200) {
                showNotification.success(`${entitiesLabels.SUCCESS}`,'Successfully saved');
               
                this.setState(
                    {
                        model: {
                            ...modelProp,
                          },
                      isLoading: false,
                      isOpenInsertModal:false,
                    },);
              } else {
                showNotification.error(`${entitiesLabels.ERROR}`,
                  getError('Unsuccessfully saved', entitiesLabels.KpiNotApplicable, apioperation.POST)
                );
              }
            })
            .catch((error) => {
              showNotification.error(`${entitiesLabels.ERROR}`,getError(error, entitiesLabels.KpiNotApplicable, apioperation.POST));
            })
            .finally(() => {
              this.setState(
                {
                    model: {
                        ...modelProp,
                      },
                  isLoading: false,
                },
                () => {
                  this.getKPINotApplicable();                                 
                  this.forceUpdate();
                }
              );
            });
        } else {
          this.validator.showMessages();
          showNotification.warning(`${entitiesLabels.WARNING}`,
            `${entitiesLabels.KpiNotApplicable} required fields are missing  `
          );
          this.forceUpdate();
        }
    };
    deleteItem = () => {
        let id = this.state.idToDelete;
        this.setState({
          isDeleting: true,
        });
        const datiForm = this.state.itemList.find(x => x.id == id)
    
        
        kpi
          .delete(datiForm)
          .then((response) => {
            if (response.status == 200) {
              this.setState({
                idToDelete: null,
                isOpenDeleteModal: false,
              });
              this.onCloseConfirm();
              this.getKPINotApplicable();
              showNotification.success(`${entitiesLabels.SUCCESS}`,getSuccess(entitiesLabels.KPI, apioperation.DELETE));
            } else {
              showNotification.error();
            }
          })
          .catch((error) => {
            showNotification.error(`${entitiesLabels.ERROR}`,getError(error, entitiesLabels.KPI, apioperation.DELETE));
          })
          .finally(() => {
            this.setState({
              isDeleting: false,
            });
          });
      };
////MODELLO
    onChange = (selectedItem) => {
        const items = selectedItem ? selectedItem.selectedItems : null;
        const statusCopy = { ...this.state };
        statusCopy.model.listWorkSite = items;
        statusCopy.selectedItems= items;

        this.setState(statusCopy);
    };
    onChangeSearch = (selectedItem) => {
      const items = selectedItem ? selectedItem.selectedItems : null;
      const statusCopy = { ...this.state };
      statusCopy.search.listWorkSite = items;
      statusCopy.selectedItems= items;

      this.setState(statusCopy);
  };       
    handleChangeComboSearch = (inputName, selectedItem, objName) => {
      const inputValue =   selectedItem ?  inputName!= 'quarter' ? selectedItem.id : selectedItem : null;
      const statusCopy = { ...this.state };
      statusCopy[objName][inputName] = inputValue;
      this.setState(statusCopy);
  };     
    handleChangeCombo = (inputName, selectedItem, objName) => {
        const inputValue = selectedItem ? selectedItem.id : null;
        
        const statusCopy = { ...this.state };
        statusCopy[objName][inputName] = inputValue;
        statusCopy.model.quarter= null;
        statusCopy.model.year= 0;
        statusCopy.model.listWorkSite = null;
        statusCopy.selectedItems= [];
       
        
        this.setState(statusCopy);
    };
    handleChangeComboQuarter= (inputName, selectedItem, objName) => {
        const inputValue= selectedItem ? selectedItem  : null;
        
        const statusCopy = { ...this.state };
        
        if(this.state.model.idKpi != null && this.state.model.year != null && selectedItem != null ){
            var listWSkpinotApplicable= this.state.listKpi.find( ws => ws.idKpi ==  this.state.model.idKpi &&   ws.year ==  this.state.model.year &&   ws.quarter == selectedItem );
            if(listWSkpinotApplicable != null){
                const filterWs =  this.state.worksites.filter( x =>  !listWSkpinotApplicable.listWorkSite.some(y => y.id == x.id) )
                statusCopy.listWorkSites= filterWs;
            }else{
                statusCopy.listWorkSites = this.state.worksites;
            }
        }else{
          statusCopy.listWorkSites = this.state.worksites;
        }
        statusCopy[objName][inputName] = inputValue;
        statusCopy.model.idKpi =this.state.model.idKpi ;
        statusCopy.model.listWorkSite = null;
        statusCopy.selectedItems= [];
        this.setState(statusCopy);
      };
      handleChangeModel = (el) => {
        const inputName = el.target.name;
        const inputValue = el.target.value;
        const objName = el.target.alt;
    
        this.updateState(inputName, inputValue, objName);
    };
    handleChangeModelSearch = (el) => {
      const inputName = el.target.name;
      const inputValue = el.target.value;
      const objName = el.target.alt;
  
      this.updateStateSearch(inputName, inputValue, objName);
  };
  updateStateSearch = (inputName, inputValue, objName) => {
    const statusCopy = { ...this.state.search };
     statusCopy[inputName] = inputValue;
    this.setState({ search: statusCopy });
};
    updateState = (inputName, inputValue, objName) => {
        const statusCopy = { ...this.state.model };
        if (objName && objName != 'model') statusCopy[objName][inputName] = inputValue;
        else statusCopy[inputName] = inputValue;
        statusCopy.quarter=null;
        statusCopy.listWorkSite = null;
        
        this.setState({ model: statusCopy , selectedItems:[]});
    };
///MODALI
    addNew() {
       
        this.setState({
          isEditModal: false,
          isOpenInsertModal: true,
          selectedItems: [],
        });
    }
    DetailsForm = (id) => {
        this.setState({
            DetailModalId: id
            , isOpenDetailsModal: true
        });

    }
    closeDetailsForm = () => {
        this.setState({
            model: {
              id:null,
              idKpi:null,
              quarter:null,
              listWorkSite:null,
              year:0
              },
            isOpenInsertModal: false,
            selectedItems: [],
            oldIdKpi:null,
            oldYear:null,
            oldQuarter:null,
        });
        this.validator.hideMessages();
    }
    confirmDelete = (id) => {
        this.setState({
          idToDelete: id,
          isOpenDeleteModal: true,
          isDeleting: false,
        });
      };
      getNameById = (id) => {
        if (id == null) return '';
        let element = this.state.listKpiNotApplicable.find((el) => el.id == id);
        return element != null ? element.name : '';
      };
      onCloseConfirm = () => {
        this.setState({
          isOpenDeleteModal: false,
        });
      };

      //Filter
      toggleSearchForm(e) {
        e.preventDefault();
        this.setState((oldState) => ({ isOpenSearchForm: !oldState.isOpenSearchForm }));
      }
      handleClickCancelSearch = (e) => {
        e.preventDefault();
        this.setState(
          {
            search: {
              ...searchProp,
            },
            isOpenSearchForm:false,
            selectedItemsSearch:[]
          },
          () => {
            this.getKPINotApplicable({ page: 1 });
          }
        );
      };
      handleClickSearch = (e) => {
        e.preventDefault();
        this.getKPINotApplicable({ page: 1 });
      };
//MODALE DETTAGLIO
    renderDetailsForm() {
        const modalHeader = {
            title: "Add new KPI Not Applicable",
            iconDescription: 'Close',
            buttonOnClick: () => this.closeDetailsForm()
        };
        const validations = {
            idWorksite: this.validator.message(
              'worksite',
              this.state.model.listWorkSite,
              'required'
            ),
            year: this.validator.message(
              'year',
              this.state.model.year ,
              'numeric|min:1,num'
            ),
            quarter: this.validator.message(
              'quarter',
              this.state.model.quarter,
              'required'
            ),
            kpi: this.validator.message(
              'idKPI',
              this.state.model.idKpi,
              'required'
            ),
          };
        const id = this.state.DetailModalId;
        let itemList = this.state.itemList || [];
        const Details = itemList.find(el => el.id == id);;
        return (
            <ComposedModal
                className="light-modal"
                open={this.state.isOpenInsertModal}
                danger="false"
                onClose={() => this.closeDetailsForm()}
            >
                <ModalHeader className="margin-modal" {...modalHeader} >
                </ModalHeader>
                <ModalBody className="margin-modal margin-modal-content " >
                    <Form className="bx--grid--full-width">
                        <div className="bx--row">
                            <FormGroup legendText="" className="bx--col-md-12 bx--col-lg-12">
                            <FormLabel >
                            Kpi*
                            </FormLabel>
                            <ComboBox
                                id="idKpi"
                                placeholder=" "
                                name="idKpi"
                                alt="model"
                                onChange={this.handleChangeCombo}
                                itemToString={item => (item.name ?  item.code +' - ' +item.name : '')}
                                initialSelectedItem={this.state.model.kpiAI != null ? this.state.model.kpiAI : []}
                                items={this.state.kpiAI}
                                invalid={validations.kpi != null}
                            />
                            {validations.kpi}
                            </FormGroup>
                            <FormGroup legendText="" className="bx--col-md-12 bx--col-lg-12">
                            <FormLabel className="some-class">
                            Year*
                            </FormLabel>
                            <TextInput
                                id="year"
                                name="year"
                                alt="model"
                                placeholder=""
                                min={0}
                                value={this.state.model.year == 0 ? '': this.state.model.year}
                                onChange={this.handleChangeModel}
                                type="number"
                                hideLabel
                                labelText=""
                                disabled={this.state.model?.idKpi != null ? false:true}
                                invalid={validations.year != null}
                            />
                            {validations.year}
                            </FormGroup>
                            <FormGroup legendText="" className="bx--col-md-12 bx--col-lg-12">
                            <FormLabel className="some-class">
                            Quarter*
                            </FormLabel>
                            <ComboBox
                                key={'idquarter' + this.state.model.quarter}
                                id="idquarter"
                                placeholder=""
                                name="quarter"
                                alt="model"
                                onChange={this.handleChangeComboQuarter}
                                itemToString={item => (item ? item : '')}
                                initialSelectedItem={this.state.model.quarter !=  null ?this.state.model.quarter  : [] }
                                items={this.state.quarter}
                                direction='bottom'
                                disabled={this.state.model?.year != 0 ? false:true}
                                invalid={validations.quarter != null}
                                />
                                {validations.quarter}
                            </FormGroup>
                            <FormGroup legendText="" className="bx--col-md-12 bx--col-lg-12">
                            <FormLabel className="some-class">
                            WorkSite*
                            </FormLabel>
                            <MultiSelect.Filterable
                            key={'idWs' + this.state.model.quarter + this.state.model.year}
                                id="idWs"
                                disabled={this.state.items < 1 || this.props.disabled}
                                placeholder={
                                this.state.selectedItems < 1
                                    ? 'Choose one or more items'
                                    : this.state.selectedItems.map((elem) => elem.name).join(', ')
                                }
                                itemToString={(item) => (item ? item && item.name : '')}
                                items={this.state.listWorkSites != null ?this.state.listWorkSites : []}
                                light={false}
                                onChange={this.onChange}
                                type="default"
                                initialSelectedItems={this.state.model.listWorkSite != null ?this.state.model.listWorkSite : [] }
                                disabled={this.state.model?.quarter != null ? false:true}
                                direction='top'
                                size='lg'
                                className="open-up-combo-box"
                                invalid={validations.idWorksite != null}
                                />
                                {validations.idWorksite}
                            </FormGroup>
                            
                        </div>
                    </Form>
                </ModalBody>
                <div className="bx--modal-footer">
                    <Button className="button--max-width" kind="secondary" onClick={this.closeDetailsForm}>
                    Cancel
                    </Button>

                    <Button
                    className="button--max-width"
                    kind="primary"
                    disabled={this.state.editingDisabled}
                    onClick={this.insertKpiNotApplicable}
                    >
                    Save
                    </Button>
                </div>
            </ComposedModal>);
    }
//MODALE FILTRI
renderSearchform() {
  return (
    this.state.isOpenSearchForm && (
      <div>
        <Form autoComplete="off" className="bx--row" onSubmit={this.handleClickSearch}>
        <FormGroup legendText="" className="bx--col-md-6 bx--col-lg-6">
                            <FormLabel >
                            Kpi
                            </FormLabel>
                            <ComboBox
                                id="idKpiSearch"
                                placeholder="All"
                                name="idKpi"
                                alt="search"
                                onChange={this.handleChangeComboSearch}
                                itemToString={item => (item.name ?  item.code +' - ' +item.name : '')}
                                initialSelectedItem={this.state.search.idKpi != null ? this.state.search.idKpi : []}
                                items={this.state.kpiAI}
                                
                            />
           </FormGroup>
           <FormGroup legendText="" className="bx--col-md-6 bx--col-lg-6">
                            <FormLabel className="some-class">
                            Year
                            </FormLabel>
                            <TextInput
                                id="yearsearch"
                                name="year"
                                alt="search"
                                placeholder="All"
                                min={0}
                                value={this.state.search.year == 0 ? 'All': this.state.search.year}
                                onChange={this.handleChangeModelSearch}
                                type="number"
                                hideLabel
                                labelText=""
                               
                            />
                            </FormGroup>
                            <FormGroup legendText="" className="bx--col-md-6 bx--col-lg-6">
                            <FormLabel className="some-class">
                            Quarter
                            </FormLabel>
                            <ComboBox
                                id="idquartersearch"
                                placeholder="All"
                                name="quarter"
                                alt="search"
                                onChange={this.handleChangeComboSearch}
                                itemToString={item => (item ? item : '')}
                                initialSelectedItem={this.state.search.quarter !=  null ?this.state.search.quarter  : [] }
                                items={this.state.quarter}
                                direction='top'
                               />
                            </FormGroup>
                            <FormGroup legendText="" className="bx--col-md-6 bx--col-lg-6">
                            <FormLabel className="some-class">
                            WorkSite
                            </FormLabel>
                            <MultiSelect.Filterable
                                key={'idWs' + this.state.search.quarter + this.state.search.year}
                                id="idWs"
                                disabled={this.state.items < 1 || this.props.disabled}
                                placeholder={
                                this.state.selectedItemsSearch < 1
                                    ? 'All'
                                    : this.state.selectedItemsSearch.map((elem) => elem.name).join(' , ')
                                } 
                                itemToString={(item) => (item ? item && item.name : '')}
                                items={this.state.worksites}
                                light={false}
                                onChange={this.onChangeSearch}
                                type="default"
                                className="open-up-combo-box"
                                initialSelectedItems={this.state.search.listWorkSite != null ?this.state.search.listWorkSite : [] }
                                size='lg'
                                />
                            </FormGroup>
               </Form>
        <div className="searchFormFooter">
          <Button
            className="button--max-width"
            size="small"
            kind="secondary"
            onClick={this.handleClickCancelSearch}
          >
            Cancel
          </Button>
          <Button className="button--max-width" size="small" onClick={this.handleClickSearch}>
            Search
          </Button>
        </div>
      </div>
    )
  );
}
//Download
downloadFile() {
  if (this.state.isExportLoading) return;

  this.setState({
    isExportLoading: true,
  });
  api
    .getWithParam(baseUrl + 'excel', { responseType: 'arraybuffer' })
    .then((response) => {
      //fileDownload(new Blob([response.data]), 'report.xlsx');
      var data = new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      var csvURL = window.URL.createObjectURL(data);
      var tempLink = document.createElement('a');
      tempLink.href = csvURL;

      var nomefile = 'Export_' + 'Worksite_' + moment().format('YYYYMMDDHHmmSS') + '.xlsx';
      tempLink.setAttribute('download', nomefile);

      document.body.appendChild(tempLink);
      tempLink.click();
    })
    .catch((error) => {
      showNotification.error(`${entitiesLabels.ERROR}`,getError(error, 'Download File', apioperation.GET));
    })
    .finally(() => {
      this.setState({
        isExportLoading: false,
      });
    });
}
/////RENDER 
    render() {
        this.validator.purgeFields();//si usa quando ci sono validazioni condizionali tra più campi
        const headersDataTable = [
            { key: 'code', header: 'Code' },
                      { key: 'name', header: 'Name' },
                      { key: 'year', header: 'Year' },
                      { key: 'quarter', header: 'Quarter' },
                      { key: 'numberworksite', header: 'Worksites' },

        ];
        const paginationProps = () => ({
            page: this.state.currentPage || 1,
            totalItems: this.state.rowCount || 0,
            pageSize: this.state.pageSize || 10,
            pageSizes: [10, 20, 30, 40, 50],
            onChange: this.handleChangePaging,
        });
        const confirmDelProps = () => ({
            idToDelete: this.state.idToDelete,
            nameItem: this.getNameById(this.state.idToDelete),
            isDeleting: this.state.isDeleting,
            open: this.state.isOpenDeleteModal, //open state
            onCloseConfirm: this.onCloseConfirm, //no click
            deleteItem: this.deleteItem, //yes click fn()
          });
        const skeletonRowCount = (this.state.rowCount > 0 && this.state.pageSize > this.state.rowCount) ? this.state.rowCount : 5;
        return (
            <AppContext.Consumer>{
                ({ user }) =>
                    <>
                        <PageBreadCrumb
                            linkTo={'/backoffice'}
                            linkText={'BackOffice'}
                            titleLeft={'KPI Not Applicable'}
                        />
                        <div className="mainContainer">
                        <ConfirmAlertCustom {...confirmDelProps()} />
                        {this.state.isOpenInsertModal ? this.renderDetailsForm() : ''}
                        <TableToolbar>
                                        <form onSubmit={this.handleSearchFormSubmit} className="max-width" autoComplete="off">
                                        <Online> <Search
                                            readOnly
                                            light
                                            className="search cursor-pointer hiddenSearch"
                                            labelText="Search"
                                            placeHolderText="Search"
                                            id="search-1"
                                            onClick={this.toggleSearchForm}
                                          />
                                        </Online>
                                        </form>
                                        <Online>
                                        <Button
                                            onClick={this.toggleSearchForm}
                                            className="buttonPaddingIcon"
                                            renderIcon={Data16}
                                            iconDescription="Filter"
                                          />
                                        <Button onClick={() => this.downloadFile()} className="btn-notext" iconDescription=" " renderIcon={Download16}>{!this.state.isExportLoading ? "" : <Loading></Loading>}</Button>
                                        </Online>
                                        <Online>
                                        {
                                            !this.state.isReadOnly &&
                                            (this.state.isLoadingSchema ? <ButtonSkeleton />
                                                : <Button onClick={() => this.addNew()} renderIcon={Add16}>Add New</Button>)
                                        }
                                        </Online>
                                    </TableToolbar>
                                    {!this.state.isExportLoading ? '' : <Loading></Loading>}
                                    {this.renderSearchform()}
                            <DataTable
                                rows={this.state.itemList || []}
                                headers={headersDataTable}
                                useZebraStyles={true}
                                size="compact"
                                render={({ rows, headers, getHeaderProps, getRowProps, getTableProps, getSelectionProps, selectedRows, getBatchActionProps }) => (
                                    <TableContainer className="bx--grid--full-width" title=""  >
                                        {this.state.isLoadingEntity ?
                                            <DataTableSkeleton headers={[]} rowCount={skeletonRowCount} zebra={false} compact={false} />
                                            :
                                            <Table>
                                                <TableHead>
                                                    <TableRow>

                                                        {headers.map(header => (
                                                            <TableHeader className={header.type == "bool" ? "align-center" : ""} {...getHeaderProps({ header })} >
                                                                {header.header}
                                                            </TableHeader>
                                                        ))}
                                                        <TableHeader className="align-center">Actions</TableHeader>
                                                    </TableRow>

                                                </TableHead>
                                                <TableBody>
                                                    {
                                                        (rows == null || rows.length == 0)
                                                            ?
                                                            <NoRecordsPlaceholder colSpan={headers.length} />
                                                            :
                                                            rows.map((row) => (
                                                                <TableRow {...getRowProps({ row })}>
                                                                    {
                                                                        row.cells.map(cell =>
                                                                            <RenderDataTableCell key={cell.id} cell={cell} header={headers.find(x => x.key === cell.info.header)} />
                                                                        )}
                                                                    <TableCell key={'action-' + row.id} className="tableActions align-center">
                                                                        <div>
                                                                        <Online>
                                                                            <Button
                                                                                onClick={() => this.getKPIForEdit(row.id)}
                                                                                size="small"
                                                                                renderIcon={Edit16}
                                                                                iconDescription="Edit"
                                                                                kind="ghost"
                                                                            />
                                                                            <Button
                                                                                onClick={() => this.confirmDelete(row.id)}
                                                                                size="small"
                                                                                renderIcon={Delete16}
                                                                                iconDescription="Delete"
                                                                                kind="ghost"
                                                                            />
                                                                            </Online>
                                                                        </div>
                                                                    </TableCell>
                                                            </TableRow>
                                                            ))}
                                                </TableBody>
                                            </Table>
                                        }
                                    </TableContainer>
                                )}
                            />
                            <div className="footer-pagination">
                                <Pagination {...paginationProps()} />
                            </div>
                        </div>
                    </>
            }
            </AppContext.Consumer>)
    }
}
